<template>
  <span
    ><i class="far fa-calendar-exclamation c-coral mr-2"></i
    >{{ $t('EVENTS.LABEL.CANCELLED') }}</span
  >
</template>

<script>
export default {
  name: 'EventCancelledComponent',
};
</script>

<style scoped></style>
